import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { corporateColor, greyBg } from '../../../../theme/colors'
import { DOBRA } from '../../../../theme/fonts'

interface Props {
  title: string
}

export const GrayHeader = ({ title }: Props) => {
  return (
    <View style={style.container}>
      <Text style={style.title}>{title}</Text>
    </View>
  )
}

const style = StyleSheet.create({
  container: {
    backgroundColor: greyBg,
    padding: 24,
  },
  title: {
    fontFamily: DOBRA,
    fontWeight: '500',
    textAlign: 'center',
    fontSize: 18,
    color: corporateColor,
  },
})
